export class FirebaseAuthError extends Error {
  public constructor(errorCode?: string) {
    super()

    this.message = errorCode ? `firebaseErrors.authCodes.${errorCode}` : 'firebaseErrors.unknown'
  }
}
